import {
  COLOR_CHART_MARKET_OTB,
  COLOR_LEGEND_ITEM_CAPACITY,
  COLOR_LEGEND_ITEM_GROUP,
  COLOR_LEGEND_ITEM_LY,
  COLOR_LEGEND_ITEM_MY_OTB,
  COLOR_LEGEND_ITEM_TRANSIENT,
  COLOR_LEGEND_ITEM_TRANSIENT_FILL,
  COLOR_PARITY_LOSS,
  COLOR_PARITY_LOSS_LIGHT,
  COLOR_PARITY_MEET,
  COLOR_PARITY_MEET_LIGHT,
  COLOR_PARITY_WIN,
  COLOR_PARITY_WIN_LIGHT,
  COLOR_SHORT_TERM_RENTAL_OTB,
  COLOR_SHORT_TERM_RENTAL_RATE,
  getCssVariableString,
} from 'frontend-utils/utils/css-variable';
import { PARITY_FILTER } from 'lumen/utils/constants/pi-constant-values';

export const TRANSIENT = getCssVariableString(COLOR_LEGEND_ITEM_TRANSIENT);

export const TRANSIENT_FILL = getCssVariableString(
  COLOR_LEGEND_ITEM_TRANSIENT_FILL,
);

export const GROUP = getCssVariableString(COLOR_LEGEND_ITEM_GROUP);

export const TOTAL_OTB = getCssVariableString(COLOR_LEGEND_ITEM_MY_OTB);

export const LAST_YEAR = getCssVariableString(COLOR_LEGEND_ITEM_LY);

export const CAPACITY = getCssVariableString(COLOR_LEGEND_ITEM_CAPACITY);

export const MARKET_OTB = getCssVariableString(COLOR_CHART_MARKET_OTB);

export const SHORT_TERM_RENTAL_OTB_COLOR = getCssVariableString(
  COLOR_SHORT_TERM_RENTAL_OTB,
);

export const SHORT_TERM_RENTAL_RATE_COLOR = getCssVariableString(
  COLOR_SHORT_TERM_RENTAL_RATE,
);

export const PARITY_COLORS = {
  [PARITY_FILTER.LOSS]: {
    fillColor: `var(${COLOR_PARITY_LOSS})`,
    color: `var(${COLOR_PARITY_LOSS_LIGHT})`,
  },
  [PARITY_FILTER.MEET]: {
    fillColor: `var(${COLOR_PARITY_MEET})`,
    color: `var(${COLOR_PARITY_MEET_LIGHT})`,
  },
  [PARITY_FILTER.WIN]: {
    fillColor: `var(${COLOR_PARITY_WIN})`,
    color: `var(${COLOR_PARITY_WIN_LIGHT})`,
  },
};

export const PREDICTED_PARITY_COLORS = {
  [PARITY_FILTER.LOSS]: {
    fillColor: `var(${COLOR_PARITY_LOSS_LIGHT})`,
    color: `var(${COLOR_PARITY_LOSS})`,
  },
  [PARITY_FILTER.MEET]: {
    fillColor: `var(${COLOR_PARITY_MEET_LIGHT})`,
    color: `var(${COLOR_PARITY_MEET})`,
  },
  [PARITY_FILTER.WIN]: {
    fillColor: `var(${COLOR_PARITY_WIN_LIGHT})`,
    color: `var(${COLOR_PARITY_WIN})`,
  },
};
